export default __webpack_public_path__ + "static/media/eseasa_offshore.3f745088.png";